import { useRequest } from "../utils/api";
import { ListMapResponseType } from "./map.type";

const GET_LIST_MAP = '/v1/rms/map/'
export const useListMap = (obj = {} as { enabled?: boolean, page_size ?: number}) => {
  return useRequest<ListMapResponseType>(GET_LIST_MAP, { ...obj, layout:true }, {enabled: obj.enabled})
}